<p-autocomplete
  [(ngModel)]="locationGroup"
  [disabled]="disabled()"
  [dropdown]="true"
  [suggestions]="locationGroupList"
  (completeMethod)="search($event)"
  (onSelect)="onLocationGroupChange($event.value)"
  (onClear)="onLocationGroupChange(null)"
  placeholder="Please select"
  minQueryLength="3"
  [appendTo]="appendTo()"
  [showEmptyMessage]="true"
  [required]="required()"
  [forceSelection]="true"
  optionLabel="name"
>
  <ng-template let-location #item>
    {{ location.name }}
  </ng-template>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Location group not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
